// One-time "Confirm voice ownership" consent — persisted so the popup is only
// shown before the user's very first voice-clone upload on this device.
export const VOICE_CLONE_CONSENT_KEY = 'voice-clone-consent-confirmed'
